import React,{useState} from 'react'
import ImageDrawModal from "../canvas/ImageDrawModal";
import ImageDrawCard from "../canvas/ImageDrawCard";
import thumb1 from '../images/thumb_01.jpg';
import thumb2 from '../images/thumb_02.jpg';
import thumb3 from '../images/thumb_03.jpg';
import thumb4 from '../images/thumb_04.jpg';

import img1 from '../images/1.png';
import img2 from '../images/2.png';
import img3 from '../images/3.png';
import img4 from '../images/4.png';

import "./modal.css";


export default function EyeLids(){
    const [show,setShow] = useState(false);
   const [title,setTitle] = useState("Eye Lids");
   const [showImage,setShowImage] = useState(img1);

   const handleShow = (subtitle,imagename)=>{
        setTitle(subtitle)
        setShowImage(imagename)
        setShow(true)
   }
   const cards = [
       { title: "Lids 3/4", thumb: thumb1, image: img1 },
       { title: "Lids Front", thumb: thumb2, image: img2 },
       { title: "Lids Profile", thumb: thumb3, image: img3 },
       { title: "Lids Closeup", thumb: thumb4, image: img4 },
   ]
    return(
        <>
            <div className="card shadow-sm border-0 mb-4">
                <div className="card-body py-4">
                    {/* Heading */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className="h5 fw-bold mb-0">Eye Lids</h3>
                    </div>

                    {/* Gallery */}
                    <div className="row g-4 row-cols-2 row-cols-md-3 row-cols-lg-5">
                        {cards.map((c, i) => (
                            <ImageDrawCard
                                key={i}
                                title={c.title}
                                thumb={c.thumb}
                                image={c.image}
                                onClick={handleShow}
                            />
                        ))}

                    </div>
                </div>
            </div>
            {/* Reusable modal */}
            {showImage && (
                <ImageDrawModal
                    show={show}
                    title={title}
                    image={showImage}
                    onClose={() => setShow(false)}
                />
            )}
        </>
    )
}